export default __webpack_public_path__ + "static/media/minimalinv-banner-desktop.519df500.jpg";